import React from 'react';
import { object } from 'prop-types';
import { CheckIcon } from 'components/Icons';

function Check(props) {
    const { row, col } = props;

    return row[col.id] ? <CheckIcon /> : '-';
}

Check.propTypes = {
    row: object,
    col: object,
};

Check.defaultProps = {
    row: {},
    col: {},
};

export default Check;
